import React, { useCallback } from "react";

import { Button } from "@mui/material";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import { useNavigate } from "hooks";
import { PostReachOutRes } from "store/types";

import "./ReachOut.styles.scss";

const style = {
  position: "absolute" as "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)"
};

interface Props {
  data?: PostReachOutRes;
  close: () => void;
}

export const ReachOut: React.FC<Props> = ({ data, close }) => {
  const { email, deal_id, form_id, section_id } = data || {};

  const navigate = useNavigate();

  const goToForm = useCallback(() => {
    if (!deal_id || !form_id || !section_id) return;
    close();
    navigate({
      route: "dealForm",
      params: { deal_id, form_id },
      setQueriesMethod: "replace",
      search: { section: section_id }
    });
  }, [deal_id, form_id, section_id]);

  return (
    <Modal open={!!data} onClose={close}>
      <Box sx={style}>
        <div className="reach-out-modal opacity-appearance">
          <div className="head">Form Submitted Successfully</div>
          <div className="body">
            <div className="section">
              <div className="text">A new form has been created and sent to</div>
              <div className="text--underline">{email}</div>
            </div>
            <div className="section">
              <div className="text">You can view the form by clicking on the following link:</div>
              <div onClick={goToForm} className="text--underline text--animated">
                [Link to the form]
              </div>
            </div>
          </div>
          <div className="footer">
            <Button variant="contained" onClick={close}>
              Ok
            </Button>
          </div>
        </div>
      </Box>
    </Modal>
  );
};
